// src/components/Footer.js
import React from "react";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-grid">

        {/* Brand */}
        <div className="footer-brand">
          <div className="logo-wrap">
            <div className="logo-icon">M</div>
            <div className="logo-text">Mech<span>Folks</span> Technologies</div>
          </div>
          <p>
            Engineering the Web. Mastering the Data. Growing your Brand.
            We are your all-in-one digital technology partner for the modern era.
          </p>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/in/mechfolks-technologies-b10b753b5" target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.instagram.com/mechfolks_technologies/" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://github.com/infomechfolkstechnologies-bot" target="_blank" rel="noreferrer">
              <i className="fab fa-github"></i>
            </a>
            <a href="https://wa.me/919940546432" target="_blank" rel="noreferrer">
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>

        {/* Company Links */}
        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#why-us">Why Us</a></li>
            <li><a href="#insights">Architecture</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Services Links */}
        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li><a href="#services">Data Engineering</a></li>
            <li><a href="#services">Web Development</a></li>
            <li><a href="#services">Digital Marketing</a></li>
            <li><a href="#services">Mobile Apps</a></li>
            <li><a href="#services">E-commerce</a></li>
            <li><a href="#services">SEO &amp; Content</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4>Contact</h4>
          <div className="footer-contact-item">
            <i className="fas fa-map-marker-alt"></i>
            <span>Bangalore, Karnataka, India</span>
          </div>
          <div className="footer-contact-item">
            <i className="fas fa-envelope"></i>
            <span>infomechfolkstechnologies@gmail.com</span>
          </div>
          <div className="footer-contact-item">
            <i className="fas fa-phone"></i>
            <span>+91 99405 46432</span>
          </div>
          <div className="footer-contact-item">
            <i className="fas fa-clock"></i>
            <span>Mon–Sat: 9 AM – 7 PM IST</span>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© 2026 MechFolks Technologies. All rights reserved.</p>
        <div className="footer-bottom-links">
          <a href="#home">Privacy Policy</a>
          <a href="#home">Terms of Service</a>
        </div>
      </div>

      {/* WhatsApp Float */}
      <a
        href="https://wa.me/919940546432"
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

    </footer>
  );
}

export default Footer;
